import React, { useState } from 'react';

const AddTransactionModal = ({ isOpen, onClose, onSubmit }) => {
    const [type, setType] = useState('expense');
    const [data, setData] = useState({ date: new Date().toISOString().split('T')[0], description: '', amount: '', category: 'Feed' });
    
    if (!isOpen) return null;

    const handleChange = e => setData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    
    const handleSubmit = e => {
        e.preventDefault();
        const finalData = { ...data, type };
        if (type === 'income') delete finalData.category;
        onSubmit(finalData);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-lg m-4">
                <h2 className="text-2xl font-bold mb-4">Add Transaction</h2>
                <div className="mb-6 border-b border-gray-200">
                    <nav className="-mb-px flex space-x-6">
                        <button onClick={() => setType('expense')} className={`py-2 px-3 font-medium text-sm rounded-t-md ${type === 'expense' ? 'border-b-2 border-indigo-500 text-indigo-600' : 'text-gray-500 hover:text-gray-700'}`}>Expense</button>
                        <button onClick={() => setType('income')} className={`py-2 px-3 font-medium text-sm rounded-t-md ${type === 'income' ? 'border-b-2 border-indigo-500 text-indigo-600' : 'text-gray-500 hover:text-gray-700'}`}>Income</button>
                    </nav>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div><label className="block text-sm font-medium text-gray-700">Date</label><input name="date" type="date" value={data.date} onChange={handleChange} required className="mt-1 w-full p-2 border rounded"/></div>
                        <div><label className="block text-sm font-medium text-gray-700">Amount (₹)</label><input name="amount" type="number" step="0.01" value={data.amount} onChange={handleChange} required className="mt-1 w-full p-2 border rounded"/></div>
                        {type === 'expense' && <div><label className="block text-sm font-medium text-gray-700">Category</label><select name="category" value={data.category} onChange={handleChange} className="mt-1 w-full p-2 border rounded"><option>Feed</option><option>Medical</option><option>Labor</option><option>Utilities</option><option>Other</option></select></div>}
                        <div className="col-span-full"><label className="block text-sm font-medium text-gray-700">Description</label><input name="description" value={data.description} onChange={handleChange} required className="mt-1 w-full p-2 border rounded"/></div>
                    </div>
                    <div className="mt-8 flex justify-end space-x-3">
                        <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300">Cancel</button>
                        <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700">Add Transaction</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddTransactionModal;